/* eslint-disable no-unused-vars */
import { QuestionFormField, QuestionFormFieldType } from './questionFormField'

/**
 * Creates an instance of EmailAddressField.
 * @typedef {Object} EmailAddressFieldType
 * @property {string} placeholder
 *
 * @typedef {QuestionFormFieldType & EmailAddressFieldType} EmailAddressFieldExtendType
 */

/**
 * Represents an email address form field.
 * @class
 */
export class EmailAddressField extends QuestionFormField {
  /**
   * Create a new EmailAddressField.
   * @param {EmailAddressFieldExtendType} params
   */
  constructor(params) {
    super(params)
    this.placeholder = params.placeholder
  }
}
